export default {
  en: {
    title: 'Calls history',
    subtitle: 'List of calls.',
    columns: {
      agent: 'Agent',
      department: 'Segment',
      date: 'Date',
      transferred: 'Transferred',
      resolved: 'Resolved',
    },
    agentDeleted: 'Agent was deleted',
    departmentDeleted: 'Segment was deleted',
    view: {
      answered: 'Answered',
      dismissed: 'Dismissed',
      assigned: 'Assigned',
      timeout: 'Timeout',
      acdHistory: 'ACD History',
      transferredBy: 'Transfer by',
      transferredTo: 'Transferred to',
      transferredFrom: 'Transferred from',
      viewCallTo: 'View call destination',
      viewCallFrom: 'View call source',
      spyModeButton: 'Start supervision',
      spyMode: {
        errorTitle: 'Live supervision error',
        errorDefault: 'Could not start live supervision. Please try again later.',
        '451': 'The feature is not enabled by the administrator',
        '403': 'You do not have permission to supervise calls',
      },
    }
  },
  es: {
    title: 'Historial de llamadas',
    subtitle: 'Listado de llamados.',
    columns: {
      agent: 'Agente',
      department: 'Segmento',
      date: 'Fecha',
      transferred: 'Transferido',
      resolved: 'Resuelto',
    },
    agentDeleted: 'El agente fue eliminado',
    departmentDeleted: 'El segmento fue eliminado',
    view: {
      answered: 'Contestada',
      dismissed: 'Rechazada',
      assigned: 'Asignada',
      timeout: 'Tiempo agotado',
      acdHistory: 'Historial ACD',
      transferredBy: 'Transferido por',
      transferredTo: 'Transferido a',
      transferredFrom: 'Transferido desde',
      viewCallTo: 'Ver llamada de destino',
      viewCallFrom: 'Ver llamada de origen',
      spyModeButton: 'Iniciar supervisión',
      spyMode: {
        errorTitle: 'Error en supervision en vivo',
        errorDefault: 'No se pudo iniciar la supervisión en vivo. Por favor, inténtelo de nuevo más tarde.',
        '451': 'La función no está activada por el administrador',
        '403': 'No tienes permiso para supervisar llamadas',
      },
    }
  },
  fr: {
    title: 'Historique des appels',
    subtitle: 'Liste des appels.',
    columns: {
      agent: 'Agent',
      department: 'Segment',
      date: 'Date',
      transferred: 'Transféré',
      resolved: 'Résolu',
    },
    agentDeleted: 'L\'agent a été supprimé',
    departmentDeleted: 'Le segment a été supprimé',
    view: {
      answered: 'Répondu',
      dismissed: 'Rejeté',
      assigned: 'Assigné',
      timeout: 'Délai expiré',
      acdHistory: 'Histoire de l\'ACD',
      transferredBy: 'Transféré par',
      transferredTo: 'Transféré à',
      transferredFrom: 'Transféré de',
      viewCallTo: 'Voir l\'appel de destination',
      viewCallFrom: 'Voir l\'appel d\'origine',
      spyModeButton: 'Démarrer la supervision',
      spyMode: {
        errorTitle: 'Erreur de supervision en direct',
        errorDefault: 'Impossible de démarrer la supervision en direct. Veuillez réessayer plus tard.',
        '451': 'La fonction n\'est pas activée par l\'administrateur',
        '403': 'Vous n\'avez pas la permission de superviser les appels',
      },
    }
}

};
